import { DatabaseOutlined } from "@ant-design/icons";
import { ADMIN_PREFIX_PATH } from "configs/AppConfig";

const dashBoardNavTree = [
  {
    key: "daftar-perusahaan-koperasi",
    path: `${ADMIN_PREFIX_PATH}/daftar-perusahaan-koperasi`,
    title: "Daftar Perusahaan Koperasi",
    icon: DatabaseOutlined,
    permissions: ["MANAGE_COOPERATIVE"],
    breadcrumb: false,
    submenu: [],
  },
];

const navigationConfigAdminCooperative = [...dashBoardNavTree];

export default navigationConfigAdminCooperative;
